import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosService from '../../../utility/axiosService/axiosService';
import { API_ENDPOINT } from '../../../utility';
import { toast } from 'react-toastify';

export const getCampaignProductList = createAsyncThunk(
    'users/getCampaignProductList',
    async (data) => {
        if (data == 'all') {
            return await axiosService
                .get(`${API_ENDPOINT}/admin/campaign-product`, {
                    params: {
                        limit: 100
                    }
                })
                .then((res) => {
                    return res.data;
                });
        } else {
            return await axiosService
                .get(`${API_ENDPOINT}/admin/campaign-product`, {
                    params: data
                        ? {
                              page: data.page,
                              search: data.keyword
                          }
                        : {
                              page: 1,
                              search: ''
                          }
                })
                .then((res) => {
                    return res.data;
                });
        }
    }
);

const campaignProductSlice = createSlice({
    name: 'campaignProduct',
    initialState: {
        loading: false,
        modal: false,
        data: [],
        total_page: 0,
        dataCampaignProduct: [],
        dataDetailsProduct: null,
        error: null,
        // keyword: "",
        // page: 1,
        dataFilter: {
            keyword: '',
            page: 1
        }
    },
    reducers: {
        getModal: (state, { payload }) => {
            state.modal = true;
            state.dataDetails = payload;
        },
        removeModal: (state) => {
            state.dataDetails = null;
            state.modal = false;
        },
        searchTextFieldSlice: (state, { payload }) => {
            state.keyword = payload.data;
        },
        paginationHandleSlice: (state, { payload }) => {
            state.page = payload.data;
        },
        filterData: (state, { payload }) => {
            state.dataFilter.keyword = payload.page
                ? payload.keyword || state.dataFilter.keyword
                : payload.keyword;
            state.dataFilter.page = payload.page || state.dataFilter.page;
        }
    },
    extraReducers: {
        [getCampaignProductList.pending]: (state) => {
            state.loading = true;
        },
        [getCampaignProductList.fulfilled]: (state, { payload }) => {
            state.dataCampaignProduct = payload.data.result;
            state.total_page = payload.data.total_page;
            state.loading = false;
        }
    }
});

export const { getModal, removeModal, filterData, searchTextFieldSlice, paginationHandleSlice } =
    campaignProductSlice.actions;

export default campaignProductSlice.reducer;
